import React, { ReactNode } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import { Tooltip } from "flowbite-react";

interface InfoTagProps {
    message?: string | " "
}

const InformationTag: React.FC<InfoTagProps> = ({message}) => {
    return (
        <Tooltip content={message} style="dark">
            <IoInformationCircle className="text-lg" />
        </Tooltip>
    )
}

export default InformationTag;